<div class="activation-link-plans">
  <gdp-activation-link-form
  [formControl]="activationFormControl"
  ></gdp-activation-link-form>
  <div class="submit-container">
    <button class="vox-btn vox-btn-primary" type="submit"
    [disabled]="activationFormControl.invalid" (click)="onSubmit()"
    [ladda]="loading">
      {{'sales.activation-link.form.button' | translate}}
    </button>
  </div>
</div>

<ng-template #activationPlansLinkPopup let-modal>
  <gdp-copy-feedback-popup
    [title]="'sales.copy-activation-link-modal.title' | translate"
    [feedback]="'sales.copy-activation-link-modal.link-copied' | translate"
    [content]="modalContent">
    <div class="link-container">
      <a [href]="modalContent" target="_blank" class="link">{{modalContent}}</a>
    </div>
  </gdp-copy-feedback-popup>
</ng-template>
